import { Table, Input, Space, Button } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom"
import { SearchOutlined } from '@ant-design/icons';
import useMemberProfilesList from "../../hooks/useMemberProfilesList";
import useRunsList from "../../hooks/useRunsList";
import Highlighter from 'react-highlight-words';

function MembersRunDataTable() {
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const params = useParams();

  const memberProfilesList = useMemberProfilesList(`?_id=${params.member_id}`);
  const runList = useRunsList("");

  useEffect(() => {
    const tempRunListData = []

    memberProfilesList?.map((member_profiles_list_data) => {
      runList?.map((run_list_data) => {

        run_list_data?.participants?.map((participant_data) => {

          if (participant_data.member_id === member_profiles_list_data.member_id) {
            tempRunListData.push({
              "key": run_list_data._id,
              "_id": run_list_data._id,
              "run_number": run_list_data.run_number,
              "run_name": run_list_data.run_name,
              "run_date": run_list_data.run_date,
              "run_status": participant_data.run_status
            })
          }

          return null
        })

        return null
      })

      return null
    })

    setData(tempRunListData)

  }, [memberProfilesList, runList])

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Run Number",
      dataIndex: "run_number",
      sorter: (a, b) => a.run_number - b.run_number,
      sortOrder: 'descend',
      ...getColumnSearchProps('run_number'),
    },
    {
      title: "Run Name",
      dataIndex: "run_name",
      ...getColumnSearchProps('run_name'),
    },
    {
      title: "Run Date",
      dataIndex: "run_date",
      ...getColumnSearchProps('run_date'),
    },
    {
      title: "Run Status",
      dataIndex: "run_status"
    }
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      bordered
      pagination
      scroll={{ x: 1500 }}
    />
  );
}

export default MembersRunDataTable;
